import React from "react";
import GlobalStyles from 'styles/GlobalStyles';
import {Helmet} from 'react-helmet';
import { getCanonicalUrl } from 'helpers/canonicalUrl';

import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import ContactUs from "./pages/ContactUs";
import FAQs from "./pages/FAQs";
import UseCases from "./pages/UseCases";
import ResearchPapers from "./pages/ResearchPapers";
import ResearchViewPage from "./pages/ResearchViewPage";
import Home from "./pages/home/Home";
import LandingPage from "./LandingPage";
import Thankyou from "./pages/Thankyou";
import MRIMAI from "./pages/mrimai/MRIMAI";
import StudyViewPage from "./pages/StudyViewPage";
import Conferences from "pages/Conferences";
import ConferenceViewPage from "pages/ConferenceViewPage";
import AchilliesStudyViewPage from "./pages/AchilliesStudyViewPage";

export default function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;
  const routes = [
    {path: "/mrimai", component: MRIMAI, title: "MRI MAI - Advanced 3D Motion Analysis with Volumetric MRI Integration | MAI Motion"},
    {path: "/live", component: LandingPage, title: "MAI Motion - Revolutionary 3D Motion Analysis Technology for Healthcare Professionals"},
    {path: "/thankyou", component: Thankyou, title: "Thank You - Welcome to the Future of Motion Analysis | MAI Motion"},
    {path: "/about-us", component: AboutUs, title: "Mai Motion - At MAI-Motion, we’re pioneering a revolutionary approach to understanding human movement, bringing together a unique blend of expertise across medical, technological, and scientific disciplines."},
    {path: "/contact-us", component: ContactUs, title: "Contact MAI Motion - Get Expert Support for 3D Motion Analysis Solutions"},
    // {path: "/blogs/:slug", component: BlogViewPage},
    {path: "/research/:slug", component: ResearchViewPage},
    {path: "/study/achilles-tendon-treatment-study", component: AchilliesStudyViewPage},
    {path: "/study/:slug", component: StudyViewPage},
    {path: "/conferences/:slug", component: ConferenceViewPage},
    // {path: "/blogs", component: Blogs, title: "Mai Motion - A Systematic Approach to Regeneration"},
    {path: "/research", component: ResearchPapers, title: "Research & Publications - Ongoing Studies, Upcoming Projects & Scientific Papers | MAI Motion"},
    {path: "/conferences", component: Conferences, title: "Conferences & Events - MAI Motion Presentations & Healthcare Innovation | MSK Doctors Research"},
    {path: "/pricing", component: Pricing, title: "Mai Motion - Find the perfect plan for your needs by comparing the features included in each. Whether you're an individual patient, a doctor managing a practice, or an administrator overseeing a clinic, we have tailored plans to suit your requirements."},
    {path: "/faqs", component: FAQs, title: "Frequently Asked Questions - 3D Motion Analysis & MRI Technology Support | MAI Motion"},
    {path: "/use-cases", component: UseCases, title: "Mai Motion - In rehabilitation settings, MAI-Motion plays a crucial role in assessing patients’ functional movements after surgery or injury. It provides objective data on range of motion, joint stability, and muscle activation, enabling therapists to tailor rehabilitation programs and track progress effectively."},
    {path: "/", component: Home, title: "MAI Motion - Capturing Movement, Enhancing Health"},
  ];

  return (
    <>
      <GlobalStyles/>
      <Router>
        <Routes>
          {routes.map(({path, component: Component, title}, index) => (
              <Route key={index} exact path={path} element={
                <>
                  {title && (
                      <Helmet>
                        <title>{title}</title>
                        <link rel="canonical" href={getCanonicalUrl(path)}/>
                        <meta name="description" content={title}/>
                        <meta property="og:title" content={title}/>
                        <meta property="og:description" content={title}/>
                        <meta name="twitter:title" content={title}/>
                        <meta name="twitter:description" content={title}/>

                        {["/live", "/thankyou"].includes(path) && (
                            <script>
                              {`
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '2144532016022644');
                fbq('track', 'PageView');
              `}
                            </script>
                        )}

                        {path === "/live" && (
                            <noscript>
                              {`<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=2144532016022644&ev=PageView&noscript=1"/>`}
                            </noscript>
                        )}

                        {path === "/thankyou" && (
                            <script>
                              {`fbq('track', 'StartTrial');`}
                            </script>
                        )}

                      </Helmet>
                  )}
                  <Component/>
                </>
              }/>

          ))}
        </Routes>
      </Router>
      <div style={{ display: "none" }}>
        <a href="/live">MRI MAI Motion</a>
        <a href="/mrimai">Live</a>
        <a href="/thankyou">Thank You</a>
        <a href="/about-us">About Us</a>
        <a href="/contact-us">Contact Us</a>
        {/*<a href="/blogs">Blogs</a>*/}
        <a href="/research">Research</a>
        <a href="/pricing">Pricing</a>
        <a href="/faqs">FAQs</a>
        <a href="/use-cases">Use Cases</a>
      </div>
    </>
  );
}
